module.exports = __webpack_public_path__ + "assets/img/role-32c785d2.png";